import { Group } from "@mantine/core"
import { useTranslation } from "react-i18next"
import classes from "./Question.module.css"
import { ButtonQuestion } from "./QuestionButton"
import type { TQuestionProps } from "./types"

export function QuestionBoolean({ value, setValue, preview }: TQuestionProps) {
  const { t } = useTranslation()
  const miw = preview ? 100 : 200

  return (
    <Group gap="xs" mb="xs" wrap="nowrap">
      <ButtonQuestion
        flex={1}
        maw={miw}
        preview={preview}
        color={value === 100 ? "green" : "gray"}
        classNames={classes}
        style={{ "--color-hover": "var(--mantine-color-green-5)" }}
        variant={value === 100 ? "filled" : "outline"}
        onClick={() => setValue(100)}
      >
        {t("Yes")}
      </ButtonQuestion>
      <ButtonQuestion
        flex={1}
        maw={miw}
        preview={preview}
        classNames={classes}
        color={value === 0 ? "red" : "gray"}
        style={{ "--color-hover": "var(--mantine-color-red-5)" }}
        variant={value === 0 ? "filled" : "outline"}
        onClick={() => setValue(0)}
      >
        {t("No")}
      </ButtonQuestion>
    </Group>
  )
}
